import { Component, OnInit, OnChanges, OnDestroy, Input, Output, NgZone, EventEmitter, ViewChild, ElementRef, PLATFORM_ID, Inject, SimpleChanges } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
// ngrx store
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
// import 'rxjs/add/operator/catch';
import { catchError } from 'rxjs/operators';
// models
import { CollectionLocation } from '../../../models/collection.interface';
import { GetLocationItem } from '../../../models/get-location.interface';
// service
import { CollectionService } from '../../../services/collection.service';
import { EventsService } from '../../../services/events.service';
import { GeocodeService } from '../../../services/map-geocode.service';
import { SharedService } from '../../../../shared/services/shared-service.service';
// country list
import { CountryList } from '../../../services/countriesList.service';
import { Store } from '@ngrx/store';
import { AppState } from 'app/booking/models/app-state.interface';

import moment from 'moment';
import { sbbSubsidyStatusUpdate, updateSbbPublicTransportDiscountStatus, zoneInfoUpdate } from 'app/booking/reducers/booking.actions';
import { FormsModule } from '@angular/forms';
import { LocationResidentialLookupComponent } from '@shared/components/location-residential-lookup/location-residential-lookup.component';
import { SubsidyComponent } from '../../subsidy/subsidy/subsidy.component';

declare var ga: any;
declare var exponea: any;

@Component({
  selector: 'app-residential',
  standalone: true,
  imports: [CommonModule,FormsModule, LocationResidentialLookupComponent, SubsidyComponent],
  templateUrl: './residential.component.html',
  styleUrls: ['./residential.component.scss']
})
export class ResidentialComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('postcodeElement') ele: ElementRef;

  @Input()
  bookingType;

  @Input()
  bookingState;

  @Input()
  currentBooking;

  @Input()
  userAddresses;

  @Input()
  selectedLocationId;

  @Input()
  selectedLanguage;

  @Input()
  appCopy;

  @Input()
  appAirportCopy;

  @Input()
  isSbbSubsidyApplied;

  @Input()
  isSbbSubsidyAvailable;

  @Output()
  callGetLocation: EventEmitter<any> = new EventEmitter();

  @Output()
  geoPostcode: EventEmitter<any> = new EventEmitter();

  @Output()
  selectedGeoCoords: EventEmitter<any> = new EventEmitter();

  @Output()
  updatePrice: EventEmitter<any> = new EventEmitter();

  @Output()
  handleShowMenu: EventEmitter<any> = new EventEmitter();

  @Output()
  sendToBooking: EventEmitter<any> = new EventEmitter();

  private _locationSubscription: Subscription;
  private _geoCoordsValidationSubscription: Subscription;
  private _geoSubscription: Subscription;
  private _bookingSubscription:Subscription;

  private _updatedPostcodeValue;
  private _postcodeUsedGeo = false;
  private _timeout;
  private _enteredValue;
  private _lastEnteredValue;
  private _childPrediction = '';
  private _locationArr = [];
  private _ind = 0;

  public selectedAddressLine = [''];
  public showManualInput = false;
  public showManualLocation = false;
  public postcodeInZone = true;
  public errorPostcodeNotEntered = false;
  public isLoading = false;
  public errorNoPostcode = false;
  public postcodeInvalid = false;
  public countrySelected = false;
  public cityInvalid = false;
  public postcodeError = false;
  public postcodeCheck = false;
  public formHasErrors = false;
  public geoLoading = false;
  public virtualBagsCount;

  public addressLookupPlaceholder = 'Enter your address or postcode';
  public recentAddressLabel = 'Recent addresses';
  public manuallyAddressLabel = 'Enter address manually';
  public moreAddressLabel = 'more addresses';
  public errorTextOutOfCoverageArea = 'Sorry, we can’t find any addresses in our coverage area';
  public errorTextPostCodeIsMissing = 'Please enter an address with a postcode';
  public errorTextAddLine = "Please enter your address"

  public map = null;
  public markerLocation = null;
  public defaultGeoCoord = {
    latitude: 51.507346,
    longitude: -0.127754
  };
  public locationData: CollectionLocation = {
    type: 4,
    name: '',
    shortName: '',
    geoCoord: null,
    addressLine1: '',
    addressLine2: '',
    addressTown: '',
    addressPostCode: '',
    addressCountry: ''
  };
  public postcodeData;
  public collectionAddressName;
  public isCountrySelected = false;
  public matchedCountryList = [];
  public current: any = 0;
  public isGeoCoordsValid: boolean = true;
  public isGeoCoordAvailable:boolean = true;
  public requestedDateTime = '';
  public hoursDifference = 0;
  public bookingProduct;
  public flightDirection;
  public departureAirportCode;
  public arrivalAirportCode;
  public airlineCode;
  public isSbbSubsidyApplicable: boolean = false;
  private departureInfo;
  private arrivalInfo;

  public postcodePattern = /^[a-z]{1,2}[0-9][a-z0-9]?\s?[0-9][a-z]{2}$/i;

  public countriesList = ["Switzerland", "United Kingdom", "Ireland", "Austria"];

  constructor(
    private _router: Router,
    private _collectionService: CollectionService,
    private _eventsService: EventsService,
    private _geocodeService: GeocodeService,
    private _sharedService: SharedService,
    private _ngZone: NgZone,
    private _countryList: CountryList,
    private _appStore: Store<AppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }
  ngOnChanges(changes: SimpleChanges): void {

    if (this.selectedLanguage || this.selectedLanguage === '') {
      this.updateCopy();
    }
  }

  ngOnInit() {
    this.setDataSubscriptions();
    const state = this.getState(this._appStore);
    const flightData = state.flightReducer.flightDetails.flightResponse;
    const flightStatusDetails = flightData.flightStatusDetails;
    this.airlineCode = flightStatusDetails[0].airlineCode;
    this.departureAirportCode =  this.flightDirection === 1 ? flightStatusDetails[0].departureAirport.airportCode : null;
    this.arrivalAirportCode =  this.flightDirection === 2 ? flightStatusDetails[flightStatusDetails.length - 1].arrivalAirport.airportCode : null;
    this.requestedDateTime = flightData.flightInfo.requestedDateTime;

    let date1 = moment();
    let date2 = moment(this.requestedDateTime)
    this.hoursDifference = date2.diff(date1, 'hours');

    this.bookingProduct = state.bookingReducer.bookingDetails.bookingProduct;
    this.departureInfo = flightData.flightStatusDetails[0].departureAirport;
    this.arrivalInfo = flightData.flightStatusDetails[flightData.flightStatusDetails.length - 1].arrivalAirport;
    this.updateCopy();
    if (this.isSbbSubsidyAvailable) { this.isSbbSubsidyApplicable = true; }
  }

  updateCopy() {
    this.addressLookupPlaceholder = this.appCopy.panelHeader['residentialAddressLookupPlaceholder' + this.selectedLanguage];
    this.recentAddressLabel = this.appCopy.panelHeader['recentAddressLabel' + this.selectedLanguage];
    this.manuallyAddressLabel = this.appCopy.panelHeader['manuallyAddressLabel' + this.selectedLanguage];
    this.moreAddressLabel = this.appCopy.panelHeader['moreAddressLabel' + this.selectedLanguage];
    this.errorTextOutOfCoverageArea = this.appCopy.panelHeader['errorTextOutOfCoverageArea' + this.selectedLanguage];
    this.errorTextPostCodeIsMissing = this.appCopy.panelHeader['errorTextPostCodeIsMissing' + this.selectedLanguage];
    this.errorTextAddLine = this.appCopy.panelHeader['errorTextAddLine' + this.selectedLanguage];
  }

  setDataSubscriptions() {
    // used to get data from store
    this.setCurrentStoreVars();


    // subscribe to location data sent from google places
    this._locationSubscription = this._collectionService.locationSubject$
      .subscribe(loc => {

        this._ngZone.run(() => {

          this.geoLoading = false;
          this._ind++;
          this._locationArr = [];

          // if response returns error
          // ignore response
          if (loc === 'error') {
            this.locationData.addressLine1 = this._childPrediction;
            this._locationArr.push(this.locationData.addressLine1, this._ind);
            this.selectedAddressLine = this._locationArr;
            return;
          }

          // api response error
          if (loc.error) {
            // console.log('location error', loc);
            return;
          }

          // if no postcode
          // or postcode is not in postcode array
          // throw error
          if (loc[0] === 'empty postcode') {
            this.errorNoPostcode = true;
            return;
          } else if (loc[0] === 'not in zone') {
            this.postcodeInZone = false;
            const currentUrl = location.pathname;
            ga('send', 'event', 'Error', 'Sorry – your postcode is outside our coverage area.', currentUrl);
            return;
          } else if (loc === 'no place id') {
            this.errorPostcodeNotEntered = true;
            return;
          }

          this.locationData = loc.location;
          this.isGeoCoordAvailable = loc.location.geoCoord !== null;
          this.selectedGeoCoords.emit(this.locationData.geoCoord);

          this._locationArr.push(this.locationData.addressLine1, this._ind);
          this.selectedAddressLine = this._locationArr;

          this.locationData.name = '';

          this.updatePrice.emit({postCode: this.locationData.addressPostCode, goeCoord: this.locationData.geoCoord});

          this.showManualInput = true;

          this._appStore.dispatch(zoneInfoUpdate({ payload: loc.zoneInfo }));
        });

      });

    this._geoCoordsValidationSubscription = this._collectionService.geoCoordsSubject$
      .subscribe(
        e => {
          this.isSbbSubsidyApplicable = false;
          this._appStore.dispatch(updateSbbPublicTransportDiscountStatus({ payload: false }));
          this._appStore.dispatch(sbbSubsidyStatusUpdate({ payload: e?.response?.isSbbSubsidyApplicable }));
          this.isLoading = false;
          if (e.isValid && e.isCalled) {
            this.isGeoCoordsValid = true;
            this.postcodeInZone = true;
            this.isSbbSubsidyApplicable = e.response.isSbbSubsidyApplicable;
            this._appStore.dispatch(zoneInfoUpdate({ payload: e.response.zoneInfo }));
          } else {
            this.isGeoCoordsValid = false;
            this.postcodeInZone = false;
            const currentUrl = location.pathname;
            this.exponeaAddressEvent();
            ga('send', 'event', 'Error', 'Sorry – your postcode is outside our coverage area.', currentUrl);
          }
        });

    this._geoSubscription = this._geocodeService.geocodeSubject$
      .subscribe(geo => {

        if (geo === 'no results') {
          this.postcodeInvalid = true;
          this.postcodeCheck = false;
          this.formHasErrors = true;
          return;
        } else if (geo === 'postcode error') {
          this.errorPostcodeNotEntered = true;
          this.postcodeCheck = false;
          this.formHasErrors = true;
          return;
        }

        this._postcodeUsedGeo = true;
        this.locationData.addressPostCode = this._updatedPostcodeValue;
        this.locationData.geoCoord = geo;

        this.selectedGeoCoords.emit(this.locationData.geoCoord);

        this.postcodeCheck = false;
        this.geoLoading = false;
        if (!this.isLoading) {
          // move map
          this.postcodeCheck = false;
          this.updatePrice.emit({postCode: this.locationData.addressPostCode.replace(/\s/g, '').toLocaleUpperCase(), goeCoord: this.locationData.geoCoord});
        }
      },
        err => console.log(err));

    // if location set in booking
    // and type matches tab
    // set locationData to values
    if (
      this.currentBooking.bookingCompletion.collectionLocationDetails &&
      this.currentBooking.bookingJourney[0].collectionLocation.type === 4 &&
      this.flightDirection === 1
    ) {
      this.locationData = JSON.parse(JSON.stringify(this.currentBooking.bookingJourney[0].collectionLocation));
      this._locationArr = [];
      this._locationArr.push(this.locationData.addressLine1, 0);
      this.selectedAddressLine = this._locationArr;

      this.selectedGeoCoords.emit(this.locationData.geoCoord);

      this.showManualInput = true;
    } else if (
      this.currentBooking.bookingCompletion.deliveryLocationDetail &&
      this.currentBooking.bookingJourney[0].deliveryLocation.type === 4 &&
      this.flightDirection === 2
    ) {
      this.locationData = JSON.parse(JSON.stringify(this.currentBooking.bookingJourney[0].deliveryLocation));
      this._locationArr = [];
      this._locationArr.push(this.locationData.addressLine1, 0);
      this.selectedAddressLine = this._locationArr;

      this.selectedGeoCoords.emit(this.locationData.geoCoord);

      this.showManualInput = true;
    }

  }

  // set booking state to vars
  setCurrentStoreVars() {
    this.flightDirection = this.bookingState.bookingDetails.journeyLegDetails[0].journeyDirection;
    this._bookingSubscription = this._appStore.select('bookingReducer').subscribe(booking => {
      this.virtualBagsCount = booking.bookingDetails.virtualBagCount;
    });
  }

  toggleShowMenu(event) {
    this.handleShowMenu.emit(event);
  }

  clearInput() {
    this.locationData = {
      type: 4,
      name: '',
      shortName: '',
      geoCoord: null,
      addressLine1: '',
      addressLine2: '',
      addressTown: '',
      addressPostCode: '',
      addressCountry: ''
    };
    this.selectedAddressLine = [''];
    this.showManualInput = false;
    this.changedAddressLine('');
    this.handleShowMenu.emit(true);
    this.selectedGeoCoords.emit(this.locationData.geoCoord);
    this.isGeoCoordAvailable = true;
    this.isSbbSubsidyApplicable = false;
    this._appStore.dispatch(sbbSubsidyStatusUpdate({ payload: false }));
    this._appStore.dispatch(updateSbbPublicTransportDiscountStatus({ payload: false }));
  }

  changedAddressLine(event) {
    this.locationData.addressLine1 = event;
    this.errorNoPostcode = false;
    this.formHasErrors = false;
  }

  // type ahead address search
  // from allies api
  // component location-residential-lookup
  getChildLocation(event) {
    this.isLoading = true;
    this.resetValidation();
    this._childPrediction = event.Description;
    const state = this.getState(this._appStore);
    const request: GetLocationItem = {
      locationProvider: 3,
      locationType: 4,
      searchId: event.selectedItem.Id,
      partialSearch: event.selectedItem.Text + event.selectedItem.Description,
      airportCode: event.airportCode,
      airline: state.flightReducer.flightDetails.flightResponse.flightStatusDetails[0].airlineCode
    };

    this.callGetLocation.emit(request);
  }

  selectedSavedLocationResidential(event) {
    this.postcodeInZone = true;
    this.locationData = JSON.parse(JSON.stringify(event));
    this._locationArr = [];
    this._locationArr.push(this.locationData.addressLine1, 0);
    this.selectedAddressLine = this._locationArr;
    this.isLoading = true;

    if (this.bookingProduct === 'abc') {
      this._collectionService.validatLocationGeoCoords({ airline: this.airlineCode, airportCode: this.departureInfo.airportCode, geoCoord: this.locationData.geoCoord })
    } else {
      this._collectionService.validatLocationGeoCoords({ airline: this.airlineCode, airportCode: this.arrivalInfo.airportCode, geoCoord: this.locationData.geoCoord })
    }
    this.selectedGeoCoords.emit(this.locationData.geoCoord);

    this.showManualInput = true;
  }

  resetValidation() {
    this.errorNoPostcode = false;
    this.postcodeInZone = true;
    this.postcodeInvalid = false;
    this.countrySelected = false;
    this.errorPostcodeNotEntered = false;
    this.cityInvalid = false;
    this.postcodeError = false;
    this.formHasErrors = false;
  }

  handleSubmitLocation(form, e: Event) {
    e.preventDefault();

    let valid = true;
    this.resetValidation();
    this.locationData.addressLine2 = this.locationData.addressLine2.trim();
    if (typeof form.value.collectionAddressLine1 === 'undefined'
      || !form.value.collectionAddressLine1
      || form.value.collectionAddressLine1 === '') {
      form.controls.collectionAddressLine1.markAsDirty();
      this.formHasErrors = true;
      valid = false;
    }
    if (form.value.collectionAddressTown === '') {
      form.controls.collectionAddressTown.markAsDirty();
      this.formHasErrors = true;
      valid = false;
    }
    if (form.value.collectionAddressCountry === '') {
      form.controls.collectionAddressCountry.markAsDirty();
      this.formHasErrors = true;
      valid = false;
    }
    if (!this.isGeoCoordsValid  || form.value.collectionAddressPostcode === '') {
      form.controls.collectionAddressPostcode.markAsDirty();
      this.formHasErrors = true;
      valid = false;
    }
    // if ((this.departureInfo.airportCountryCode !== 'CH' && this.bookingProduct === 'abc') || (this.arrivalInfo.airportCountryCode !== 'CH' && this.bookingProduct === 'ccd')){
    //   if (!this.postcodePattern.test(form.value.collectionAddressPostcode.replace(/\s/g, '').toLocaleUpperCase())) {
    //     form.controls.collectionAddressPostcode.markAsDirty();
    //     this.formHasErrors = true;
    //     valid = false;
    //   }
    // }

    if (valid) {
      const locData = JSON.parse(JSON.stringify(this.locationData));
      locData.name = form.value.collectionAddressName;
      locData.addressCountry = form.value.collectionAddressCountry;
      locData.addressLine1 = form.value.collectionAddressLine1;
      locData.addressTown = form.value.collectionAddressTown;
      locData.addressPostCode = form.value.collectionAddressPostcode;
      this.locationData = locData;
      this.isLoading = true;
      this.postcodeInZone = true;

      this.geoLoading = false;

      if (this._postcodeUsedGeo) {
        this._geoSubscription.unsubscribe();
      }
      // if user change saved address then remove locationId
      let isSameAddress = true;
      if (this.locationData.addressPostCode && this.locationData.locationId) {
        const selectedAddress = this.userAddresses.find(address => {
          return address.addressPostCode === this.locationData.addressPostCode
        });
        if (selectedAddress) {
          isSameAddress = Object.keys(locData).every(k => {
            if (typeof locData[k] === 'object') {
              return JSON.stringify(locData[k]) === JSON.stringify(selectedAddress[k])
            }
            // handle '' === null
            if ((locData[k] === '' || locData[k] === null || locData[k] === undefined) && (selectedAddress[k] === '' || selectedAddress[k] === null || selectedAddress[k] === undefined)) {
              return true
            }
            return locData[k] === selectedAddress[k]
          });
        } else {
          isSameAddress = false;
        }
      }
      if (!isSameAddress && this.locationData.locationId) {
        delete this.locationData.locationId;
      }

      this.sendToBooking.emit(this.locationData);
    } else {
      if (isPlatformBrowser(this.platformId)) {
        document.body.scrollTop = 0;
      }
    }

  }

  postcodeChange(e) {
    this.isGeoCoordsValid = true;
    this.isGeoCoordAvailable = true;
    this.postcodeInvalid = false;
    this._updatedPostcodeValue = e;
    this.getNewGeo(this._updatedPostcodeValue.replace(/\s/g, '').toLocaleUpperCase());
  }

  countryChange(countryName) {
    const countryList = this._countryList.getCountryList();
    let matchList = [];
    if (countryName.length >= 1) {
      for (const i of countryList) {
        if (i.name.slice(0, countryName.length).toUpperCase() === countryName.toUpperCase()) {
          matchList.push(i)
        }

      }
      this.matchedCountryList = matchList;
    }
  }
  handleCountrySelection(country) {
    this.locationData.addressCountry = country;
    this.matchedCountryList = [];
    this.countrySelected = true;
  }
  setCurrent(index) {
    this.current = index;
  }

  isCurrent(index) {
    return this.current === index;
  }

  selectItem() {
    const selectedItem = this.matchedCountryList[this.current];
    this.handleCountrySelection(selectedItem);
  }
  close() {
    this.matchedCountryList = [];
    this.countrySelected = false;
  }
  clearCountryInput() {
    this.countryChange('');
    this.locationData.addressCountry = '';
  }
  // to geo updated postcode value
  getNewGeo(e) {

    const cleanValue = e.replace(/ /g, '');

    if (cleanValue !== this._lastEnteredValue && cleanValue.length > 3) {
      this._lastEnteredValue = cleanValue;

      this.postcodeCheck = true;
      this.formHasErrors = false;
      this.geoLoading = true;
      this.isLoading = true;

      if (this._timeout) { clearTimeout(this._timeout); }

      this._timeout = setTimeout(() => {
        this.resetValidation();
        this._sharedService.validatePostcode(cleanValue, (res) => {
          this.geoLoading = false;
          this.postcodeCheck = false;
          this.isSbbSubsidyApplicable = false;
          this.isLoading = false;
          this._appStore.dispatch(updateSbbPublicTransportDiscountStatus({ payload: false }));
          this._appStore.dispatch(sbbSubsidyStatusUpdate({ payload: res?.data?.isSbbSubsidyApplicable }));

          if (res.data.isPostCodeValid) {
            this.isSbbSubsidyApplicable = res.data.isSbbSubsidyApplicable;
            this.formHasErrors = false;
            this.bookingProduct === 'abc' ?
              this.geoPostcode.emit({ postcode: cleanValue, countryCode: this.departureInfo.airportCountryCode })
              : this.geoPostcode.emit({ postcode: cleanValue, countryCode: this.arrivalInfo.airportCountryCode });
          } else {
            this.formHasErrors = true;
            this.postcodeInZone = false;
            this.exponeaAddressEvent();
          }
        });
      }, 1500);
    }
  }

  exponeaAddressEvent() {
    let exponeaEvent;
    let attributes = {};

    if (this.flightDirection === 1) {
      exponeaEvent = 'outside_abccoverage_area';
      attributes = {
        postcode_prefix : this.locationData.addressPostCode,
        origin_airport_code: this.departureInfo.airportCode
      }
    } else {
      exponeaEvent = 'outside_ccdcoverage_area';
      attributes = {
        postcode_prefix : this.locationData.addressPostCode,
        destination_airport_code: this.arrivalInfo.airportCode
      }
    }
    exponea.track(exponeaEvent, attributes);
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    this._locationSubscription.unsubscribe();
    this._geoCoordsValidationSubscription.unsubscribe();
    this._bookingSubscription.unsubscribe();
  }

}
